module.exports = __webpack_public_path__ + "static/media/severussnape.c9328628.jpeg";